import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import makeStyles from '@mui/styles/makeStyles';
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components

import sectionTextStyle from "styles/jss/nextjs-material-kit-pro/pages/blogPostSections/sectionTextStyle.js";

const useStyles = makeStyles(sectionTextStyle);

export default function SectionText() {
  const classes = useStyles();
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Google Cloud Training</h3>
          <p>
            Tribalism is a web analytics, cloud infrastructure and digital
            marketing company with office space in Sydney and Melbourne
            Australia. We have delivered in-house Google Cloud Infrastructure
            training sessions in Australia and overseas. We are recognised
            locally as leaders in the space with a growing reputation
            internationally as well. We’d love to assist you and your team get
            to grips with the Google Cloud stack
          </p>
        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>What to expect:</h3>
          <p>
            Sessions vary as to your requirements, but some of the areas covered
            may include:
          </p>
          <ul>
            <li>Beginner</li>
            <ul>
              <li>
                Google Cloud Platform (GCP): From the beginning – what is it?
                How is it different/similar to its competitors eg Amazon? What
                can you do with (with examples)
              </li>
              <li>
                Google Cloud Storage: The basis of GCP. What is it used for?
                What are its limitations? How do you interact with it
                Programmatically?
              </li>
              <li>
                Admin: Including Billing, User (IAM) Access, Monitoring Usage
                (Stackdriver)
              </li>
            </ul>
            <li>Intermediate</li>
            <ul>
              <li>
                Google App Engine: What is it? How it is used? Building your own
                simple app. Cost Management
              </li>
              <li>
                Google Compute Engine + Google Cloud Shell (GCS): What is a
                virtual machine? How does GCP scale up usage? Accessing VMs
                through GCS.
              </li>
              <li>
                Advanced Google BigQuery: Interacting with BigQuery
                Programatically (through GCP or locally with REST APIs), Usage
                Management (Stackdriver)
              </li>
            </ul>
            <li>Advanced</li>
            <ul>
              <li>
                Google Dataflow: Managing data transforms at scale. When to use.
                Review of Apache Beam architecture with worked examples.
              </li>
              <li>
                Google Pub/Sub: What is messaging? The problems around streaming
                data. Setting up a streaming example.
              </li>
              <li>
                Google Dataproc: How it works. Transferring your Hadoop Cluster
                (eg Apache Spark) to the GCP. Worked examples.
              </li>
              <li>
                Google Machine Learning Engine and Google Tensorflow: What is
                the ML Engine and Tensorflow? Review of Neural Networks. Run
                through of Google’s Machine Learning APIs. Run-through of an
                ML/Tensorflow example
              </li>
            </ul>
          </ul>
        </GridItem>

        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/sections/services/google-cloud-training/1.jpg"
              alt="..."
              className={imgClasses}
            />

            <p>
              <br></br>
              <i>Google Cloud Storage Example</i>
            </p>
          </GridItem>
        </div>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Flexible to your plans:</h3>
          <p>
            It is easy for us to come to you, wherever you are across Australia,
            New Zealand or the Asia Pacific region.
            <br />
            <br />
            Training agendas will be agreed with you in advance. If you like we
            can design the agenda completely for you, or if you have specific
            areas you’d like to cover we can tailor the agenda to your areas of
            focus.
            <br />
            <br />
            Or rates are very competitive and will be agreed with you in
            advance. If you are interested please don’t hesitate to drop us a
            line so we can get your Google Analytics implementation in top
            shape.{" "}
          </p>
        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Our guarantee to you</h3>

          <ol>
            <li>
              Quality: We will deliver quality work. It's the first thing all of
              our staff are trained in - “completed” is not good enough - it
              needs to be done well!
            </li>
            <li>
              Communication: We cannot guarantee that everything will be perfect
              the first time. Most things aren't. But what we can guarantee is
              easy communication to anyone in our business to discuss any issues
              and fix any problems asap.
            </li>
            <li>
              Innovative: We are anti-silo. Like life - you can't just focus on
              one thing to fix your problems. We are well versed on every facet
              of this field - and with that comes innovative approaches to your
              business issues.
            </li>
          </ol>

          <br />
          <br />
          <br />
        </GridItem>
      </GridContainer>
    </div>
  );
}
